export class StyleOrderid {
    styleOrderId?:number
  
    constructor(styleOrderId?:number){
        this.styleOrderId = styleOrderId
    }
}